import React from 'react';
import "./BlockPage.css"
import cnsl from "../../accets/img/cnsl.png"
import {NavLink} from "react-router-dom";

const BlockPage = () => {
    return (
        <div className="screen__block">

            <div className="screen-1">
                <div className="blocked__page__block">
                    <div className="blocked__page__warning">
                        <img src={cnsl} alt={cnsl}/>
                        <div className="blocked__page__warning__text">Ваш пользователь заблокирован!!!</div>
                    </div>
                    <div className="blocked__page__warning__text">Обратитесь к аддминистратору или
                        <NavLink className="blocked__page__link" to="/login">Войдите</NavLink>
                    </div>
                    <div className="blocked__page__warning__text">под другим пользователем</div>
                </div>
            </div>

        </div>
    );
};

export default BlockPage;